import React from 'react';

const ProgressBar = ({ progress, className = '', showLabel = false, size = 'normal' }) => {
  const sizeClasses = {
    small: 'h-1',
    normal: 'h-2',
    large: 'h-3'
  };

  const clampedProgress = Math.max(0, Math.min(100, progress || 0));

  return (
    <div className={`w-full ${className}`}>
      {showLabel && (
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-secondary-700">Progress</span>
          <span className="text-sm text-secondary-500">{Math.round(clampedProgress)}%</span>
        </div>
      )}
      <div className={`bg-secondary-200 rounded-full ${sizeClasses[size]}`}>
        <div
          className="bg-primary-500 rounded-full h-full transition-all duration-300 ease-out"
          style={{ width: `${clampedProgress}%` }}
          role="progressbar"
          aria-valuenow={clampedProgress}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
